export default __webpack_public_path__ + "static/media/banner.3a84bc1f.png";